import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule, MatIconRegistry} from "@angular/material/icon";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {Router, RouterLink} from "@angular/router";
import {AuthenticationService} from "../../../../domain/services/auth/authentication.service";
import {ToasterService} from "../../../../common/toaster/toaster.service";
import {ToasterContainerComponent} from "../../../../common/toaster/toaster-container/toaster-container.component";
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    RouterLink,
    ToasterContainerComponent,

  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  hide = true;
  isLoading = false;
  constructor(private readonly router: Router,
              private readonly auth: AuthenticationService,
              private readonly toasterService: ToasterService,private matIconRegistry: MatIconRegistry,
              private domSanitzer: DomSanitizer,
           ) {
            this.matIconRegistry.addSvgIcon(
              'arrow-icon',
              this.domSanitzer.bypassSecurityTrustResourceUrl("icons/arrow-icon.svg")
            );
  }

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  passwordFormControl = new FormControl('', [
    Validators.required,
  ]);

  form: FormGroup = new FormGroup({
    email: this.emailFormControl,
    password: this.passwordFormControl,
  });

  login() {
    if(this.form.invalid){
      return;
    }

    this.isLoading = true;
    this.auth.loginUser(this.emailFormControl?.value!, this.passwordFormControl.value!)
      .subscribe(() => {
        this.isLoading = false;
        this.router.navigate(['/']);
      }, error => {
        this.isLoading = false;
        this.toasterService.show('error', 'Incorrect username or password',
          'Uh-oh! The username or password you entered doesn\'t match our records. Please try again!');
      });
  }

  @Input() error: string | null | undefined;
}
